import { useCallback } from 'react';
import useRouter from 'use-react-router';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { SETTINGS_SMS_ACTIVATE_PATH } from '../constants/routes';
import { usePhoneNumber } from './use-phone-number';

export const useActivateSmsRedirectCallback = () => {
  const chatbotId = useSelector(activeChatbotIdSelector);

  const {
    location,
    history,
    match: {
      params: { chatbotId: routerChatbotId },
    },
  } = useRouter<{ chatbotId: string }>();

  const { isSmsSupported } = usePhoneNumber();

  return useCallback(() => {
    const botId = chatbotId || Number(routerChatbotId);
    if (isSmsSupported && botId !== -1) {
      history.push({
        pathname: SETTINGS_SMS_ACTIVATE_PATH(botId),
        state: {
          navigatedFrom: {
            location: location.pathname,
            search: location.search,
          },
        },
      });
    }
  }, [
    chatbotId,
    history,
    location.pathname,
    location.search,
    routerChatbotId,
    isSmsSupported,
  ]);
};
